import * as React from 'react';
import './style.scss';

interface GlobalLoaderProps {
    message?: string;
}

export const GlobalLoader: React.FC<GlobalLoaderProps> = ({ message = 'Loading data...' }) => {
    return (
        <div className='global-loader-overlay' role='status' aria-live='polite' aria-busy='true'>
            <div className='global-loader-content'>
                <div className='spinner' />
                <p>{message}</p>
            </div>
        </div>
    );
};
